export default __webpack_public_path__ + "static/media/mediChargeLogo.379e4f72.png";